<template>
	<section class="app-container">
		<div class="container">
			<div class="checklists-component">
				<h1>Odonata Central Checklists</h1>
				<nav id="filter-menu">
					<div class="clearfix">
						<h4 class="pull-left">Filter Results</h4>
						<a class="pull-right" @click="filterOffside.close()"><i class="fa fa-close fa-2x"></i></a>
						<div class="alert alert-info clear">
							Filters that apply to sightings will include checklists with <em>any</em> sighting that matches.
						</div>
					</div>
					<sighting-filters v-if="current_user_loaded" :currentUser="current_user" @filterChanged="filterChanged" 
						apiBaseSightings="sightings."
						apiBaseChecklists="empty"
						hideExcludeiNat="true"
						hideVetting="true"
					></sighting-filters>
				</nav>
				<div class="offside-overlay"></div>
					<div class="records-filter-summary clearfix">
						<sighting-filters-summary v-model="filters"></sighting-filters-summary>
					</div>
					<div class="pull-right records-buttons">
						<button class="btn btn-primary btn-filter"><span class="fa fa-filter"></span> Filter Results</button>
					</div>
					<div v-bind:class="{ overlayLoading: loading }">
						<Paging></Paging>
						<PagingSummary v-model="meta"></PagingSummary>
						<div class="loading-overlay" v-show="loading">
							<div class="spinner-wrapper">
								<span class="spinner-text">LOADING</span>
								<span class="spinner"></span>
							</div>
						</div>
						<div class="table-responsive">
							<table class="table-records border--round table--alternate-row">
								<thead>
									<tr>
										<th>ID</th>
										<th>Date</th>
										<th>Location</th>
										<th>User</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="checklist in checklists" :key="checklist.id" class="checklist-row">
										<td>
											{{checklist.id}}
										</td>
										<td>
											<span v-if="checklist.datetime">
												{{checklist.datetime.split('T')[0] | moment(momentDisplayFormat())}} 
											</span>
										</td>
										<td class="notranslate" translate="no">
											<span v-if="checklist.location_data">
												{{checklist.location_data.display_name}}
											</span>
										</td>
										<td>
											<span v-if="checklist.user_data">
									          <router-link :to="{ name: 'profile', params: { id: checklist.user_data.id }}">
									            {{checklist.user_data.display_name}}
									          </router-link>
											</span>
										</td>
										<td>
											<router-link class="btn btn-default btn--xs" :to="{ name: 'checklist_view', params: { id: checklist.id }}">
												Details
											</router-link>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<Paging></Paging>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	name: 'ChecklistsComponent',
	metaInfo: {
      title: 'Dragonfly & Odonate Checklists and Observations',
      meta: [
        { name: "description", content: 'Dragonfly & Odonate Sightings and Observations collected from users all over the united states and the rest of the world.' },
      ],
    },
	mounted(){
		var self = this;
        self.GetAPIUser(function(user){
        	self.current_user_loaded=true;
            self.current_user = user;
        });
		var parsed_page = parseInt(this.$route.query.page);
		if (!isNaN(parsed_page)) {
			this.page = parsed_page;
		}
		if (this.$route.query.sort) {
			this.sort = this.$route.query.sort;
		}
		if (this.$route.query.sort_direction) {
			if (this.$route.query.sort_direction == "+") {
				this.sort_direction = "";
			}
			else if (this.$route.query.sort_direction == "-") {
				this.sort_direction = "-";
			}
		}

		this.filterOffside = offside( '#filter-menu', {
				buttonsSelector: '.btn-filter',
				slidingSide: 'right', 
		});

		$('.offside-overlay').click(function(){self.filterOffside.close()});

	},
	data: function(){
		return {
			checklists: [],
			meta: {
				page: 0,
				per_page: 0,
				total_pages: 0,
				total_results: 0,
			},
			page: 1,
			loading: true,
			filter_string: '',
			current_sighting_id:null,
			filterOffside:null,
			filters:null,
			current_user:null,
			current_user_loaded:false,
			needs_refresh: false,
		};
	},
	methods:{
		getData: function(){
			this.loading = true;
			var self = this;
			var qs = self.filter_string;
			qs += "&include[]=location.*";
			qs += "&include[]=user.*";
			qs += "&page=" + self.page;
      		qs += "&sort[]=-id";

			this.API({
				endpoint: 'checklists',
				querystring: qs,
				funcThen: function(response){
					self.meta = response.data.meta;
					self.checklists = self.combineSightingData(response.data);
				},
				funcAfterThen: function(){
					self.loading = false;
				}
			});
		},
		combineSightingData: function(data){
        	for (var i = 0; i < data.checklists.length; i++) {
		        data.checklists[i].user_data = data.users.find(u => u.id == data.checklists[i].user);
				data.checklists[i].location_data = data.locations.find(l => l.id == data.checklists[i].location);
		    }
		    return data.checklists;
        },
		filterChanged: function(filters, filter_string,by_user_action){
			this.filters = JSON.parse(JSON.stringify(filters));
			if (by_user_action) {
				this.page = 1;
			}
			this.filter_string = filter_string;
			this.getData();
			if (this.filterOffside) {
				this.filterOffside.close();
			}
		}
	},
	computed: {
		max_page: function(){
			return this.meta.total_pages;
		}
	},
	watch:{
		page: function(){
			let query = Object.assign({}, this.$route.query);
			query.page = this.page;
			this.$router.replace({query: query});
			this.getData();
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Checklists.vue